import { SectionLabel } from "./WhatMakesSpecial";

const supports = [
  { icon: "ri-chat-3-line", title: "24/7 Live Chat", desc: "Connect with a Rolex9 support agent instantly at any time of day or night. Live chat is the fastest way to resolve account, bonus, payment or game queries." },
  { icon: "ri-telegram-line", title: "Telegram — @rolex9au", desc: "Join the official Rolex9 Telegram channel for instant support, platform updates, exclusive promotions and community announcements. Available 24/7." },
  { icon: "ri-whatsapp-line", title: "WhatsApp Support", desc: "Reach the Rolex9 team directly via WhatsApp for quick, personal assistance. Ideal for Australian players who prefer messaging over live chat." },
  { icon: "ri-facebook-circle-line", title: "Facebook Community", desc: "Follow Rolex9 on Facebook for the latest promotions, game releases, monthly ranking updates and community news. Stay connected with the Rolex9 community." },
  { icon: "ri-question-answer-line", title: "Comprehensive FAQ", desc: "The Rolex9 FAQ covers account registration, bonus terms, payment methods, withdrawal limits and responsible gambling — available 24/7 without waiting." },
  { icon: "ri-star-line", title: "Trustpilot Reviews", desc: "Rolex9 is actively reviewed on Trustpilot. Read genuine player experiences and leave your own review — transparency and player feedback are core values." },
];

export default function CustomerSection() {
  return (
    <section id="customer" className="max-w-5xl mx-auto px-6 py-12">
      <SectionLabel>Customer Support</SectionLabel>
      <p className="text-white/40 text-sm leading-relaxed mb-10 max-w-2xl">
        Rolex9 offers round-the-clock support through live chat, Telegram, WhatsApp and Facebook. The team is always ready to help Australian players — fast, friendly and knowledgeable.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {supports.map((s, i) => (
          <div
            key={i}
            className="glass-card rounded-xl p-5 hover:border-[#c9a84c]/15 transition-all duration-300"
            style={{ borderColor: "rgba(255,255,255,0.05)" }}
          >
            <div
              className="w-9 h-9 flex items-center justify-center rounded-xl mb-4"
              style={{ background: "linear-gradient(135deg, rgba(201,168,76,0.12), rgba(107,33,168,0.12))" }}
            >
              <i className={`${s.icon} text-[#c9a84c] text-base`}></i>
            </div>
            <p className="text-white/70 font-semibold text-sm mb-1.5" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{s.title}</p>
            <p className="text-white/30 text-xs leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
